import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Column, H1, useScreenSize } from '@alto/design-system';
import React from 'react';
import styled, { css } from 'styled-components';

export const MODAL_SIZE = 'MODAL_SIZE';
export const LARGE_SIZE = 'LARGE_SIZE';
type ImgSizeType = typeof MODAL_SIZE | typeof LARGE_SIZE;

const largeCss = css`
  width: 120px;
  height: 120px;
`;

const Img = styled.img<{ imgSize?: ImgSizeType; isSMScreenOrBigger: boolean }>`
  margin: 0 auto ${SPACING.STATIC.MD.rem};
  ${({ imgSize, isSMScreenOrBigger }) => {
    switch (imgSize) {
      case MODAL_SIZE:
        return `
          width: 120px;
          height: 120px;
          ${!isSMScreenOrBigger && `width: 80px; height: 80px;`}
        `;

      case LARGE_SIZE:
        return largeCss;

      default:
        return `
          width: 80px;
          height: 80px;
          ${!isSMScreenOrBigger && `width: 60px; height: 60px;`}
        `;
    }
  }};
`;

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
const TitleText = styled(H1)<{ children?: string | any }>`
  color: ${COLORS.TEXT_COLORS.PRIMARY};
  white-space: pre-wrap;
`;

type HeaderProps = {
  readonly title: string;
};

export const Header = ({ title }: HeaderProps) => {
  return (
    <Column
      gap="MD"
      flexShrink={0}
      centerHorizontally
    >
      <TitleText center>{title}</TitleText>
    </Column>
  );
};

type HeaderImageProps = {
  readonly src: string;
  readonly alt: string;
  readonly title: string | React.ReactNode;
  readonly imgSize?: ImgSizeType;
};

export const HeaderImage = (props: HeaderImageProps) => {
  const { src, alt, title, imgSize } = props;
  const { isSMScreenOrBigger } = useScreenSize();

  return (
    <Column
      gap="SM"
      flexShrink={0}
      centerHorizontally
    >
      <Img
        src={src}
        alt={alt}
        imgSize={imgSize}
        isSMScreenOrBigger={isSMScreenOrBigger}
      />
      <H1>{title}</H1>
    </Column>
  );
};
